const config = {
  env: "local",
  // apiUrl: "http://localhost:8500/admin/",
  // apiUrl: "https://fh6j56pb-8500.inc1.devtunnels.ms/admin/",
  apiUrl: "https://api.unisongroup.com/admin/",
};

export default config;
